import CryptoJS from 'crypto-js';

// 必须与后端相同的密钥
const SECRET_KEY = 'your-secret-encryption-key-nero-2025';

// 加密函数
export function encryptData(data) {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    return ciphertext;
}

// 解密函数
export function decryptData(ciphertext) {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
}
